/**
 * Human-readable message for a failed governance mutation. The server's
 * `detail` is authoritative (it names the exact refusal: self-approval,
 * expired, already decided, no approved authorization …); the hint only
 * adds the permission the caller is missing when the server said 403.
 *
 * Client checks are UX only — the backend enforces every permission and
 * the maker<>checker rule (service + DB CHECK). This just explains the
 * refusal it already made.
 */
import { ApiError } from '../api/client';

export interface MutationErrorView {
  message: string;
  hint?: string;
}

export function describeMutationError(err: unknown, requiredPermission: string): MutationErrorView {
  if (err instanceof ApiError) {
    if (err.status === 401) {
      return { message: 'Your session has expired. Sign in again and retry.' };
    }
    if (err.status === 403) {
      return {
        message: err.message,
        hint: `Requires ${requiredPermission}; a proposer can never decide their own request.`,
      };
    }
    if (err.status === 404) {
      return { message: 'Not available for your tenant, or the request no longer exists.' };
    }
    return { message: err.message };
  }
  return { message: err instanceof Error ? err.message : 'Request failed.' };
}
